<template>
  <div class="messenger-message-forward">
    <div class="messenger-message-forward__date">
      <messenger-date
        :date="message.created_at"
      />
    </div>
    <div class="messenger-message-forward__title">{{ message.description }}</div>
  </div>
</template>

<script>
import MessengerDate from '../../../components/MessengerDate.vue'

export default {
  components: {
    MessengerDate
  },
  props: {
    message: {
      type: Object,
      required: true
    }
  }
}
</script>
